// extracted by mini-css-extract-plugin
export default {"tab":"AccionaListTabs_tab__JGyMP","noSelected":"AccionaListTabs_noSelected__3U79w","header":"AccionaListTabs_header__nef7U"};